import { useMutation} from "@tanstack/react-query";
import {
  checkEmailExists,
  registerUser,
  loginUser,
  forgotPassword,
  resetPassword,
} from "../api/auth";

/* Hook for checking if email exists*/
export const useCheckEmail = () => {
  return useMutation({
    mutationFn: checkEmailExists,
    retry: false,
  });
};

/* Hook for user registration*/
export const useRegister = () => {
  return useMutation({
    mutationFn: registerUser,
  });
};

/* Hook for user login*/
export const useLogin = () => {
  return useMutation({
    mutationFn: loginUser,
  });
};

/* Hook for password reset*/
export const useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword,
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: resetPassword,
  });
};

// /**
//  * Hook for fetching current user
//  */
// export const useCurrentUser = (token, enabled = false) => {
//   return useQuery({
//     queryKey: ["current-user", token],
//     queryFn: () => getCurrentUser(token),
//     enabled: enabled && !!token,
//     staleTime: 5 * 60 * 1000,
//     retry: 1,
//   });
// };
